import * as React from 'react';
import classNames from 'classnames';
import { FontSizeType } from '@/types/fontSize';
import styles from './Text.module.scss';
import { TextComponentProps } from './register';

type TextProps = TextComponentProps<'unset' | FontSizeType['value']>;

/**
 * CMS Text component, used for creating html text. It overrides Builder's default text component.
 * */
export const Text: React.FunctionComponent<TextProps> = ({ text, forceFontSize }) => {
	const hasForceFontSize = forceFontSize !== 'unset' && forceFontSize !== undefined;

	return (
		<div
			className={classNames(
				{ [styles.hasFontSize]: hasForceFontSize },
				/* NOTE: This class name must be "builder-text" for inline editing to work in the Builder editor */
				'builder-text',
			)}
			dangerouslySetInnerHTML={{ __html: text || '' }}
			style={
				{
					'--fontSize': hasForceFontSize ? forceFontSize : undefined,
				} as React.CSSProperties
			}
		/>
	);
};
